import { Component, inject, Input, Output, EventEmitter } from '@angular/core';
import { IItemSearch } from '../../../../models/IItemSearch';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { faBookmark as faBookmarkSolid, faCreditCard, } from '@fortawesome/free-solid-svg-icons';
import { AbsoluteMediaUriService } from '../../../../services/absolute-media-uri.service';
import { SanitizeHtmlTextPipe } from '../../../../shared/pipes/sanitize-html-text.pipe';
import { TimeLeftService } from '../../../../services/time-left.service';
import { CommonModule, NgFor, NgIf } from '@angular/common';
import { faBookmark as faBookmarkRegular } from '@fortawesome/free-regular-svg-icons';
import { AuthService, LOGIN_TYPE_TOPBAR } from '../../../../services/authentication/auth.service';
import { OidcSecurityService } from 'angular-auth-oidc-client';
import { FavoritesItemsService } from '../../../../services/favorites/favorites-items.service';
import { RouterModule } from '@angular/router';
import { ButtonModule } from 'primeng/button';




@Component({
  selector: 'app-item-horizontal-template',
  imports: [FontAwesomeModule,
    SanitizeHtmlTextPipe,
    NgFor,
    NgIf,
    CommonModule,
    RouterModule,
    ButtonModule
  ],
  templateUrl: './item-horizontal-template.component.html',
  styleUrl: './item-horizontal-template.component.scss'
})
export class ItemHorizontalTemplateComponent {

  @Input() items: IItemSearch[] | null = null;
  @Output() favoriteStatus = new EventEmitter<{ isFavorite: boolean, itemId: number }>;


  faBookmarkSolid = faBookmarkSolid;
  faBookmarkRegular = faBookmarkRegular;
  faCreditCard = faCreditCard;

  protected readonly absoluteMediaUriService = inject(AbsoluteMediaUriService);
  timeLeftService = inject(TimeLeftService);
  private readonly authService = inject(AuthService);
  private readonly oidcSecurityService = inject(OidcSecurityService);
  private readonly favoriteService = inject(FavoritesItemsService);


  isAuthenticated = this.oidcSecurityService.authenticated;

  openLoginModal(fun?: () => void) {
    this.authService.openLoginModal(LOGIN_TYPE_TOPBAR, fun ?? (() => { })
    );
  }


  toggleFavorite(itemId: number, isFavorite: boolean) {

    if (this.isAuthenticated().isAuthenticated) {
      this.changeFavoriteStatus(itemId, isFavorite);

    } else {
      this.openLoginModal(() => this.changeFavoriteStatus(itemId, isFavorite));
    }


  }

  changeFavoriteStatus(itemId: number, isFavorite: boolean) {

    if (isFavorite) {
      this.favoriteService.deleteFavorite(itemId).subscribe({
        next: () => {
          this.favoriteStatus.emit({ isFavorite, itemId });
        },
        error: (error) => {
          console.error('Favorite error:', error);
        }
      });

    } else {
      this.favoriteService.putFavorite(itemId).subscribe({
        next: () => {
          this.favoriteStatus.emit({ isFavorite, itemId });
        },
        error: (error) => {
          console.error('Favorite error:', error);
        }
      });
    }
  }

  isAmountEstimatedValue(value: string): boolean {
    const numeric = value.replace(/[^0-9.-]+/g, '');
    return numeric.trim() !== '' && !isNaN(Number(numeric));
  }

}
